<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  created() {
    this.$store.dispatch('getAreaList');
    this.$store.dispatch('getLogo');
    this.$store.dispatch('getCopyrights');
    this.$store.dispatch('getStoreData');
    this.$store.dispatch('getUnreadCount');
  }
};
</script>

<style lang="less">
@main-theme-color:#004797;
:root{
  --main-theme-color:#004797;
  --hover-color: #0652AC;
  --border-color:#5597F0;
}

#app {
  font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-popover.el-popper.backTopBox {
  top: auto !important;
  bottom: 10px;
}

.cart-popper {
  background-color: #F5F5F5;
}
.headerTitle {
  font-size: 20px;
  color: #666;
}

.addCartSuccess {
  .el-message-box__btns {
    padding-top: 30px;
  }

  .el-button {
    width: 105px;

    &.el-button--primary {
      background: var(--main-theme-color);
      border-color: var(--main-theme-color);

      &:hover, &:focus {
        background: var(--main-theme-color);
        border-color: var(--main-theme-color);
      }
    }
  }
}
.goodsDetail img{
  width: auto !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"]{
  -moz-appearance: textfield;
}

.u-line {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.u-line-two {
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.u-line-three {
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.el-button--primary.is-plain{
  background:fade(@main-theme-color,30%);
  border-color: var(--main-theme-color);
}
.el-button--primary:focus, .el-button--primary:hover{
  background:var(--main-theme-color);
  border-color: var(--main-theme-color);
}
</style>



// WEBPACK FOOTER //
// src/App.vue